import { Drill } from "../components/drill/drill";

export function DrillPage(): JSX.Element {
  return <Drill />;
}
